import { type RefObject, useCallback, useMemo, useRef, useState } from 'react';
import { useGetCommonStore } from '@/store';
import { padding, paddingMob } from '@/styles/helpers';
import useEventListener from './eventListener';

interface ScrollTopBtn {
  containerRef: RefObject<HTMLDivElement>;
  gamesContainerRightOffset: number;
  isTop: boolean;
}

export const useScrollTopBtn = (): ScrollTopBtn => {
  const useCommonStore = useGetCommonStore();

  const isMobileDevice = useCommonStore.use.isMobileDevice();

  const [gamesContainerRightOffset, setGamesContainerRightOffset] =
    useState<number>(0);
  const [isTop, setIsTop] = useState(true);

  const containerRef = useRef<HTMLDivElement>(null);

  const currPadding = useMemo(
    () => (isMobileDevice ? paddingMob : padding),
    [isMobileDevice]
  );

  const handleResize = useCallback(() => {
    if (containerRef.current !== null) {
      setGamesContainerRightOffset(
        containerRef.current.getBoundingClientRect().right -
          containerRef.current.clientWidth +
          currPadding +
          (isMobileDevice ? 16 : -56)
      );
    }
  }, [currPadding, containerRef, isMobileDevice]);

  useEventListener('resize', handleResize, undefined, true);

  useEventListener(
    'scroll',
    () => setIsTop(window.scrollY === 0),
    undefined,
    false
  );

  return { containerRef, gamesContainerRightOffset, isTop };
};
